export default __webpack_public_path__ + "static/media/random2.8f32ae54.jpeg";